/**
 * Product group slugs this codebase reasons about by name.
 *
 * The rest of this module used to derive the site page's plugin catalogue — the parent-slug lookup, the
 * group-name and bundle-icon overrides, and the per-plugin slot sums. All of it moved into the
 * assignable-subscriptions read model, which ships the finished rows, so the client no longer loads the
 * product and product-group catalogues to build them.
 */
export const KNOWN_PRODUCT_GROUP_SLUGS = {
	aiBrandInsights: "ai-brand-insights",
};
